import {apiFetch} from "../../api";
import {BASE_URL as u} from "../../../commonUrls";

const BASE_URL = `${u}/account`;
//const USER_ID = "u-c136202b-94f4-4e51-aa0b-72db0503c362";

export async function getAllAccounts(){
  const res = await apiFetch(`${BASE_URL}/user`);
  if (!res.ok) return [];
  const data = await res.json();
  return Array.isArray(data) ? data : [];
}

export async function createAccount(accountName, accountType, balance, accountNumber, comment){
  const payload = {
    userId: 0,
    accountName: accountName,
    type: accountType,
    currentBalance: Number(balance),
    isActive: true,
    accountNumber: accountNumber,
    comment: comment
  };

  const res = await apiFetch(`${BASE_URL}`,{
    method:"POST",
    headers:{ "Content-Type":"application/json"},
    body: JSON.stringify(payload)
  });

  return res.json();
}

export async function deleteAccount(id){
  await apiFetch(`${BASE_URL}/${id}`,{ method:"DELETE" });
}

export async function updateAccount(id, accountName, accountType, balance, active, accountNumber, comment){
  const payload = {
    userId: 0,
    accountName: accountName,
    type: accountType,
    currentBalance: Number(balance),
    isActive: active,
    accountNumber: accountNumber,
    comment: comment
  };

  const res = await apiFetch(`${BASE_URL}/${id}`,{
    method:"PUT",
    headers:{ "Content-Type":"application/json"},
    body: JSON.stringify(payload)
  });

  return res.json();
}
